import openSocket from 'socket.io-client';
import Cookies from "js-cookie";

const token = Cookies.get('jwt');
let socket;
// Nếu CRON_DISABLE == 0 => strapi được bật cron => tạo socket nếu timeout connect_error set socket = null
// Nếu CRON_DISABLE == 1 => strapi được tắt cron => socket = null
const CRON_DISABLE = process.env.CRON_DISABLE || 0;
if(CRON_DISABLE == 1){
  socket = null;
}
else{
  socket = openSocket(process.env.REACT_APP_API, {
    transports: ['websocket', 'polling'],
    pingTimeout: 60000
  });
  socket.on("connect_error", () => {
    // revert to classic upgrade
    socket = null;
  });
}




function addNPlayer(cb) {
  if(socket){
    socket
    .emit('authenticate', { token })
    .on('authenticated', () => {
      // console.log('authenticated');
      socket.on('updated_post', res => {
        cb(null, res)
      });
      socket.emit('addNPlayer', 1000)
    })
    .on('unauthorized', (msg) => {
      console.log(`unauthorized: ${JSON.stringify(msg.data)}`);
    });
  }
  
}

function emitLockToAllUsers(cb) {
  if(socket){
    socket
    .emit('authenticate', { token })
    .on('authenticated', () => {
      // console.log('authenticated');
      socket.on('locked_post', res => {
        cb(null, res)
      });
      socket.emit('emitLockToAllUsers', 1000);
    })
    .on('unauthorized', (msg) => {
      console.log(`unauthorized: ${JSON.stringify(msg.data)}`);
    });
  }
}

function removeSocket(eventName) {
  if(socket){
    socket.removeAllListeners(eventName);
  }
}

export {
  addNPlayer,
  emitLockToAllUsers,
  removeSocket
};